export default __webpack_public_path__ + "static/media/lato-bold.7fc33422.woff";